interface ArchiveQuery {
    paged: number;
    s: string;
    sortby: string;
    category: string;
}


async function getArchiveProducts(url: string, query: ArchiveQuery) {
    let fullUrl:URL = new URL(url);
    const searchParams = new URLSearchParams(fullUrl.search);
    searchParams.append('page', query.paged.toString());
    if (query.s) {
        searchParams.append('s', query.s);
    }
    if (query.sortby && query.sortby !== 'default') {
        searchParams.append('sortby', query.sortby);
    }
    if (query.category != "all") {
        searchParams.append('category', query.category);
    }
    fullUrl.search = searchParams.toString();
    const response = await fetch(fullUrl, {
        method: "GET",
        headers: {
        "Content-Type": "application/json",
        },
    });

    if (!response.ok) {
        throw new Error("Failed to fetch archive products");
    }

    const data = await response.json();
    if (!data || !data.data) {
        throw new Error("Invalid response from server");
    }
    return data.data;
}


export function initPerksArchive(){
    const container = document.querySelector(".pc_sp_archive_container") as HTMLDivElement;
    if (!container) return;

    const ajaxUrl = container.dataset.url;
    if (!ajaxUrl) return;

    const header = container.querySelector(".pc_sp_archive_header") as HTMLDivElement;
    const content = container.querySelector(".pc_sp_archive_grid") as HTMLDivElement;
    const loadMoreButton = container.querySelector(".pc_sp_archive_load_more_button") as HTMLButtonElement|null;
    const categorySelect = container.querySelector("#pc_sp_archive_category") as HTMLSelectElement;
    const sortSelect = container.querySelector("#pc_sp_archive_sort_by") as HTMLSelectElement;
    const searchInput = container.querySelector(".pc_sp_archive_search_bar_input") as HTMLInputElement;
    const loader = container.querySelector(".pc_sp_loader") as HTMLDivElement|null;

    let currentQuery: ArchiveQuery = {
        paged: 1,
        s: searchInput.value,
        sortby: sortSelect.value,
        category: categorySelect.value,
    };

    const fetchArchiveProducts = async (replace = true) => {
        if (loadMoreButton) {
            loadMoreButton.style.display = "none";
        }
        if (loader) {
            loader.style.display = "flex";
        }
        if (replace) {
            content.innerHTML = "";
        }
        const response = await getArchiveProducts(ajaxUrl, currentQuery);
        if (response) {
            content.innerHTML += response.content;
            if (response.total_pages > currentQuery.paged) {
                if (loadMoreButton) {
                    loadMoreButton.style.display = "block";
                }
            } else {
                if (loadMoreButton) {
                    loadMoreButton.style.display = "none";
                }
            }
        }
        if (loader) {
            loader.style.display = "none";
        }
    };

    categorySelect.addEventListener("change", (event) => {
        currentQuery.paged = 1;
        currentQuery.category = categorySelect.value;
        fetchArchiveProducts();
    });

    sortSelect.addEventListener("change", (event) => {
        currentQuery.paged = 1;
        currentQuery.sortby = sortSelect.value;
        fetchArchiveProducts();
    });

    if (loadMoreButton){
        loadMoreButton.addEventListener("click", () => {
            currentQuery.paged++;
            fetchArchiveProducts(false);
        });
    }
}
